module.exports = __webpack_public_path__ + "img/dianzan_1.99e8294a.png";